var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentFailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.65,
    cy: 41.65,
    r: 41.65,
    fill: "#CF2A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.1187 51.8682L31.1985 24.9479C30.0244 23.7739 28.121 23.7739 26.9487 24.9479L25.53 26.3645C24.3559 27.5389 24.3559 29.4424 25.53 30.6146L52.4502 57.5349C53.6246 58.7089 55.5281 58.7089 56.7003 57.5349L58.1169 56.1183C59.2932 54.946 59.2932 53.0422 58.1187 51.8682Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4502 24.9481L25.53 51.8684C24.3559 53.0424 24.3559 54.9463 25.53 56.1185L26.9465 57.5351C28.121 58.7091 30.0244 58.7091 31.1967 57.5351L58.1187 30.6167C59.2932 29.4426 59.2932 27.5392 58.1187 26.3669L56.7021 24.9503C55.5281 23.7741 53.6246 23.7741 52.4502 24.9481Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/payment-failed.ea914fdd73c644d7195392899f5e985a.svg";
export { ForwardRef as ReactComponent };